import { makeAutoObservable } from 'mobx'
import { RootStore } from './RootStore'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface BaseSettingsStore {
  // Implement later (preferably in its own file) for mocking
}

export class SettingsStore implements BaseSettingsStore {
  rootStore: RootStore


  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this, { rootStore: false })
    // makePersistable(this, {
    //   name: 'TeamsSettings',
    //   properties: [],
    //   storage: window.localStorage,
    // }).then((r) => {
    //   console.debug('Persisting data for SettingsStore')
    // })
  }
}
